import { APIService } from "./APIService"
import { AdminProfileType, Page } from "./types"

const getProfiles = (q: string, status: string | null, page?: number, size?: number) =>
  APIService.get<null, Page<AdminProfileType>>(
    `/admin/profiles?q=${q}&statuses=${
      status && status !== "all" ? status : ""
    }&page=${page}&size=${size}`,
  )
const getProfile = (id: string) => APIService.get<null, AdminProfileType>(`/admin/profiles/${id}`)
const deleteProfile = (id: string) => APIService.delete<null, null>(`/admin/profiles/${id}`)
const getOffers = (category: string | null, subcategory: string | null, page?: number) =>
  APIService.get<null, Page<AdminProfileType>>(
    `/admin/offers?category=${category && category !== "all" ? category : ""}&subcategory=${
      subcategory ?? ""
    }&page=${page}`,
  )
const generateToken = (id: string) => APIService.get<null, string>(`/admin/profiles/${id}/token`)
const setFeatureFlag = (id: string, flag: string) =>
  APIService.put<null, AdminProfileType>(
    `/admin/profiles/${id}/feature-flags/${encodeURIComponent(flag)}`,
  )
const unsetFeatureFlag = (id: string, flag: string) =>
  APIService.delete<null, AdminProfileType>(
    `/admin/profiles/${id}/feature-flags/${encodeURIComponent(flag)}`,
  )

export const AdminProfileService = {
  getProfiles,
  deleteProfile,
  getProfile,
  getOffers,
  generateToken,
  setFeatureFlag,
  unsetFeatureFlag,
}
